<template>
  <div class="tw-w-full tw-p-8">
    <div class="mb-2 tw-text-2xl tw-font-bold">What do you need to be done?</div>

    <submit-task-ajax-select
      placeholder="Search categories.."
      :search="search"
    >
      <template v-slot:option="{option}">
        <submit-task-option
          v-on:click.native.prevent="store.selectCategory(option)"
          :isActive="_.get(states.category,'id') === option.id"
          :text="option.label"
        />
      </template>
    </submit-task-ajax-select>

  </div>
</template>
<script>
  import store from './submit-task-store'
  import SubmitTaskAjaxSelect from './submit-task-ajax-select'
  import SubmitTaskOption from './submit-task-option'

  export default {
    components: {
      SubmitTaskAjaxSelect,
      SubmitTaskOption,
    },
    beforeCreate() {
      this.store = store
    },
    data: v => ({
      states: store.states,
    }),
    methods: {
      search(query, setOptions) {
        axios.get(`/api/v1/search/category`, {
          params: {query}
        }).then(resp => setOptions(resp.data.data))
      }
    }
  }
</script>
